<p-toast></p-toast>
<p-confirmDialog rejectButtonStyleClass="p-button-outlined"></p-confirmDialog>
<app-top-bar [topBarTitle]="topBarTitle"></app-top-bar>
<div
  class="bpt-main-content-container"
  *ngIf="isScreenAccessible; else screenNotAccessible"
  style="overflow: auto"
>
  <div class="card">
    <div class="flex flex-column card-container">
      <div class="mb-1">
        <p-button
          appPreventDoubleClick
          *ngIf="changeControlLookUpData?.addChangeControlAvailable"
          label="Add Change Control"
          id="addChangeControlButton"
          class="add-changeControl-button"
          icon="fa fa-plus"
          iconPos="left"
          (debounceClick)="addChangeControl()"
        ></p-button>
        <app-change-control-slider *ngIf="isChangeControlSliderOpen"
          [isChangeControlSliderOpen]="isChangeControlSliderOpen"
          (isChangeControlSliderActive)="closeChangeControlSlider($event)"
        ></app-change-control-slider>
        <app-change-control-search></app-change-control-search>
      </div>
    </div>
  </div>
</div>
<ng-template #screenNotAccessible>
  <app-error [errorMessage]="errorMessage"></app-error>
</ng-template>
